module.exports = __webpack_public_path__ + "static/media/square-four.c08735da.png";